import { MarkIcon, PlayCircleIcon } from '@/assets/icons';
import { DashedArrow, GlassContainer } from '@/components/common';

interface IIntakeExecutionCard {
  className?: string;
  title: string;
  trigger: string;
  startedBy: string;
  lastJobTime: string;
  nextJobTime?: string;
  lastJobDate: string;
  nextJobDate: string;
  duration: string;
  timezone: string;
}

export const IntakeJobExecutionCard = ({
  className,
  title,
  trigger,
  startedBy,
  lastJobTime,
  nextJobTime,
  lastJobDate,
  nextJobDate,
  duration,
  timezone,
}: IIntakeExecutionCard) => {
  return (
    <GlassContainer className={className}>
      <div className="flex flex-row justify-between items-center w-full">
        <div className="flex flex-col justify-start items-start w-full gap-1">
          <span className="text-h6 font-bold text-neutral-9 uppercase">{title}</span>
          <div className="flex flex-row justify-between items-center w-full mt-1">
            <div className="flex flex-row justify-start items-center gap-2">
              <MarkIcon className="size-4 text-neutral-7" />
              <span className="font-medium text-body-sm text-neutral-7">Trigger:</span>
            </div>
            <span className="font-medium text-body-sm text-neutral-9">{trigger}</span>
          </div>
          <div className="flex flex-row justify-between items-center w-full">
            <div className="flex flex-row justify-start items-center gap-2">
              <PlayCircleIcon className="size-4 text-neutral-7" />
              <span className="font-medium text-body-sm text-neutral-7">Started by:</span>
            </div>
            <span className="font-medium text-body-sm text-neutral-9">{startedBy}</span>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-between items-start gap-1 mt-3 w-full bg-neutral-3 border border-neutral-4 px-3 py-2 rounded-xs">
        <div className="flex flex-row justify-between items-center w-full">
          <span className="font-medium text-body-xs text-neutral-7">{lastJobDate}</span>
          <span className="font-medium text-body-xs text-neutral-7">{nextJobDate}</span>
        </div>
        <div className="flex flex-row gap-1 w-full">
          <span className="font-bold text-h6 text-neutral-9 shrink-0">{lastJobTime}</span>
          <DashedArrow duration={duration} showDuration />
          <span className="font-bold text-h6 text-neutral-9 shrink-0">
            {nextJobTime ? nextJobTime : <span className="tracking-[1px] font-bold">--:--</span>}
          </span>
        </div>
        <div className="flex flex-row justify-between items-center w-full">
          <span className="font-medium text-body-xs text-neutral-7 uppercase">({timezone})</span>
          <span className="font-medium text-body-xs text-neutral-7 uppercase">({timezone})</span>
        </div>
      </div>
    </GlassContainer>
  );
};
